import React from 'react';
import styles from './AdminExerciseList.module.scss';
import { Box, Button } from '@mui/material';
import { formatPhoneNumber } from '../AdminUserList/AdminUserList';
import dayjs from 'dayjs';
import AdminTableList from '../../../components/admin/AdminTableList/AdminTableList';
import Player from 'react-player';
// import { clubList } from '../../../redux/actions/app/clubList';
import { exerciseList } from '../../../redux/actions/app/exerciseList';
import { Add } from '@mui/icons-material';
import { useNavigate } from 'react-router';
const AdminExerciseList = () => {
  const columns = [
    {
      label: 'Порядок',
      onTransform: (val) => val?.order,
    },
    {
      label: 'Название',
      onTransform: (val) => val?.name,
    },
    {
      label: 'Адрес',
      onTransform: (val) => val?.desc ?? '-',
    },

    {
      width: '300px',
      label: 'Видео',
      onTransform: (val) =>
        val?.linkVideo ? (
          <Player
            className="Video"
            url={val?.linkVideo}
            height={'auto'}
            width={'300px'}
            controls={true}
            config={{
              file: {
                forceVideo: true,
              },
            }}
          />
        ) : (
          '-'
        ),
    },
  ];
  const navigate = useNavigate();
  return (
    <div>
      <Button
        onClick={() => {
          navigate('/admin/exercise/create');
        }}
        variant="contained"
        sx={{ display: 'flex', ml: 'auto', marginBottom: '-36.5px' }}
        endIcon={<Add />}>
        Добавить
      </Button>
      <AdminTableList title={'Упражнения'} sliceName={'app'} actionName={'exerciseList'} fetch={exerciseList} pathEdit="/admin/exercise/edit" columns={columns} textEmpty={'Упражнений нет'} noLock />
    </div>
  );
};

export default AdminExerciseList;
